import { QueryClient } from '@tanstack/react-query';

/**
 * Single shared QueryClient. Extracted from main.tsx so non-React code — the
 * web-push message handler — can invalidate queries when a status-change push
 * arrives, keeping the Notification Centre fresh without a manual refresh.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      gcTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});
